import {createSlice} from '@reduxjs/toolkit';
import {validateFields, validateField} from '../../../../utilities/validation/validator';
import {regexPatterns} from '../../../../utilities/validation/validationVariables';
import lodash from 'lodash';

const OTPVerifyCodeSlice = createSlice({
  name: 'otpVerifyCode',
  initialState: {
    form: {
      numOfAttempts: 0,
      verifyCode: '',
      valid: '',
      errors: {},
      rules: {
        verifyCode: {
          required: {value: true, error: 'לא הוזן קוד'},
          minLength: {
            value: 6,
            error: 'יש להזין 6 תווים',
          },
          pattern: {
            value: regexPatterns.numbersRegex,
            error: 'ערך לא תקין',
          },
        },
      },
    },
  },

  reducers: {
    reportAnalytics: (state, action) => {},

    clearCode: {
      reducer(state, action) {
        state.form.verifyCode = action.payload.verifyCode;
        state.form.valid = '';
        state.form.isChange = false;
      },
    },

    setVerifyCode: {
      reducer(state, action) {
        if (action.payload.verifyCode == 'clear') state.form.verifyCode = '';
        else state.form.verifyCode = action.payload.verifyCode;
      },
    },
    validateHandler: {
      reducer(state, action) {
        state.form = action.payload;
      },
      prepare(payload) {
        const form = validateFields(lodash.cloneDeep(payload));
        form.valid = true;
        return {payload: form};
      },
    },
    addAttempt: {
      reducer(state, action) {
        state.form = action.payload;
      },
      prepare(payload) {
        const form = validateFields(lodash.cloneDeep(payload));
        form.numOfAttempts = form.numOfAttempts + 1;
        return {payload: form};
      },
    },
  },
});

export const {
  changeHandler,
  validateHandler,
  keyUpHandler,
  clearCode,
  addAttempt,
  setVerifyCode,
  reportAnalytics,
} = OTPVerifyCodeSlice.actions;
export default OTPVerifyCodeSlice.reducer;
